import React from "react";
import { Link } from "react-router-dom";

import LOGO from "../../../assets/logo_rcm.jpg";
// import MenuMobile from "./MenuMobile";

const HeaderPortfolio = () => {
	return (
		<div className="header-portfolio">
			{/* <Menu /> */}
			{/* <MenuMobile /> */}

			<div className="header-portfolio__container">
				<Link to="/">
					<img src={LOGO} alt="Logo RCM" className="header-portfolio__logo" />
				</Link>

				<nav className="header-portfolio__nav">
					<ul className="header-portfolio__list">
						<li className="header-portfolio__item">
							<Link to="/blog" rel="noreferrer">
								Blog
							</Link>
						</li>

						<li>
							<a href="#services" rel="noreferrer">
								Services
							</a>
						</li>
						<li>
							<a href="#projects" rel="noreferrer">
								Projects
							</a>
						</li>
					</ul>
				</nav>
				<i className="fas fa-bars cursor" onClick={() => console.log("click to botton")} />
			</div>
		</div>
	);
};

export default HeaderPortfolio;
